import MaintenanceIcon from '@/assets/icons/common/maintenance.svg';
import { Footer } from '../Footer/Footer';
import { XButton } from '../XButton/XButton';
import { Button } from '../Common/Button';
import { ButtonType } from '@/types/components';
import { generateZendeskSupportURL } from '@/utils/support';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useTranslate } from '@/hooks/useTranslate';

export const Maintenance = () => {
  const context = useContext(CheckoutContext);
  const {
    customer,
    publisherId,
    redirectLink,
    actions: { closeCheckout },
  } = context;
  const { t } = useTranslate();
  const openSupport = () => {
    window.open(
      generateZendeskSupportURL({
        customerId: customer.id,
        orderId: '',
        publisherId,
        customerCountryCode: customer.geoLocator.countryCode2,
      }),
      '_blank'
    );
  };
  const openRedirectLink = () => {
    if (redirectLink) {
      window.location.href = redirectLink;
    }
    closeCheckout(context);
  };
  return (
    <div className="flex flex-col items-center w-full h-[calc(100dvh-5rem)]">
      <XButton onClick={() => closeCheckout(context)} />
      <div className="flex flex-col items-center justify-center gap-5 w-full flex-1">
        <img src={MaintenanceIcon} alt="maintenance" className="w-[194px] h-[238px]" />
        <div className="flex flex-col items-center justify-center gap-1">
          <div className="text-xl text-card-foreground font-bold family-Inter">{t('wellBeRightBack')}</div>
          <div className="text-base text-base-foreground font-normal family-Inter text-center">
            {t('checkoutUnavailable')}
          </div>
        </div>
        <div className="flex flex-col w-full items-center justify-center gap-2">
          <Button type={ButtonType.BLUE} onClick={() => openRedirectLink()} className="w-full max-w-[343px] h-11">
            {redirectLink ? t('backToGame') : t('backToStore')}
          </Button>
          <Button
            type={ButtonType.LIGHT}
            onClick={() => {
              openSupport();
            }}
            className="w-full max-w-[343px] h-11"
          >
            {t('support')}
          </Button>
        </div>
      </div>
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};
